import React, { useEffect, useState } from 'react'
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
    CircularProgress
} from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { Alert } from '@material-ui/lab'
import { getLeieQuickSearches, getLeieQuickSearch } from 'actions/applicants'
import { Toast } from 'components/shared/Toaster'
import { useAppContext } from 'context/AppContext'

const formatDate = (iso) => {
    if (!iso) return '—'
    try {
        return new Date(iso).toLocaleString()
    } catch {
        return iso
    }
}

const statusStyle = (status) => {
    const base = { padding: '2px 8px', borderRadius: 4, fontSize: 12, display: 'inline-block' }
    if (!status) return base
    const lower = status.toLowerCase()
    if (lower.includes('completed')) return { ...base, background: 'var(--badge-approved-bg)', color: 'var(--status-approved)' }
    if (lower.includes('no results')) return { ...base, background: 'var(--badge-review-bg)', color: 'var(--rox-lilac-ink)' }
    if (lower.includes('error')) return { ...base, background: 'var(--badge-declined-bg)', color: 'var(--status-declined)' }
    return { ...base, background: '#fff8e1', color: '#ef6c00' }
}

const LeiePreviousSearches = ({ refreshKey, onViewResult }) => {
    const { isDemoMode } = useAppContext()
    const [searches, setSearches] = useState([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        let cancelled = false
        setLoading(true)
        getLeieQuickSearches({ pagination: { page: 0, limit: 10 }, demoMode: isDemoMode })()
            .then(res => {
                if (cancelled) return
                const body = res?.response || res
                const list = body?.content || body?.response || (Array.isArray(body) ? body : [])
                setSearches(Array.isArray(list) ? list : [])
            })
            .catch(() => {
                if (!cancelled) Toast({ type: 'error', message: 'Failed to load previous searches' })
            })
            .finally(() => { if (!cancelled) setLoading(false) })
        return () => { cancelled = true }
    }, [refreshKey, isDemoMode])

    const handleView = (searchId) => {
        getLeieQuickSearch({ searchId })()
            .then(res => {
                const body = res?.response || res?.responseBody || res
                onViewResult && onViewResult({ ...res, response: body })
            })
            .catch(() => Toast({ type: 'error', message: 'Failed to load search result' }))
    }

    return (
        <div className='cardStyle'>
            <div className='uccTitleContainer mt-3'><h5>Search History</h5></div>
            {loading ? (
                <div style={{ padding: 24, textAlign: 'center' }}><CircularProgress size={20} /></div>
            ) : searches.length === 0 ? (
                <Alert severity='info'>No previous LEIE searches yet.</Alert>
            ) : (
                <TableContainer component={Paper}>
                    <Table size='small'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Search Term</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell />
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {searches.map(s => (
                                <TableRow key={s.searchId} hover>
                                    <TableCell>{s.searchTerm || '—'}</TableCell>
                                    <TableCell>
                                        <span style={statusStyle(s.status)}>{s.status || '—'}</span>
                                    </TableCell>
                                    <TableCell>{formatDate(s.createdDate)}</TableCell>
                                    <TableCell align='right' padding='none' style={{ paddingRight: 8 }}>
                                        <IconButton
                                            size='small'
                                            onClick={() => handleView(s.searchId)}
                                            aria-label='view'
                                        >
                                            <VisibilityIcon fontSize='small' />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </div>
    )
}

export default LeiePreviousSearches
